export function isNullOrUndefinedOrEmptyString(val: any) {
    return val === undefined || val === null || val === '';
  }